import Phaser from 'phaser';

export type CombatFeedbackKind = 'damage' | 'critical' | 'miss' | 'received';

/** Original Thai floral accent, drawn in code; reference artwork is not imported. */
function floral(scene:Phaser.Scene):Phaser.GameObjects.Graphics {
  const g=scene.add.graphics();
  g.fillStyle(0xad342c,.58).fillCircle(0,0,26);
  for(let i=0;i<8;i++){
    const a=i*Math.PI/4,points=[{x:0,y:-43},{x:9,y:-23},{x:0,y:-12},{x:-9,y:-23}].map(p=>({x:p.x*Math.cos(a)-p.y*Math.sin(a),y:p.x*Math.sin(a)+p.y*Math.cos(a)}));
    g.fillStyle(i%2?0xb95330:0xd06a35,.66).fillPoints(points,true);
    g.lineStyle(1,0xffc672,.35).strokePoints(points,true);
  }
  return g;
}

/** Outlined digits with trailing impressions, instead of framed badge UI. */
export function combatFeedback(scene:Phaser.Scene,x:number,y:number,amount:number,kind:CombatFeedbackKind):void {
  const critical=kind==='critical',miss=kind==='miss',compact=scene.scale.height<560;
  const label=miss?'พลาด':String(Math.max(0,Math.round(amount)));
  const size=critical?(compact?44:52):miss?26:compact?32:38;
  const color=critical?'#ffe584':kind==='received'?'#ffa38b':miss?'#d0e5e5':'#fff3d6';
  const style:Phaser.Types.GameObjects.Text.TextStyle={fontFamily:miss?'Noto Sans Thai, system-ui':'system-ui, Noto Sans Thai',fontStyle:'bold',fontSize:size+'px',color,stroke:'#251b19',strokeThickness:critical?7:5,shadow:{offsetX:2,offsetY:3,color:'#000000',blur:0,fill:true,stroke:true},letterSpacing:critical?2:1};
  const children:Phaser.GameObjects.GameObject[]=[];
  if(critical)children.push(floral(scene));
  for(let i=2;i>=0;i--){
    const echo=scene.add.text((i+1)*18,(i+1)*24,label,style).setOrigin(.5).setScale(.84-i*.16).setAlpha(0);
    children.push(echo);
    scene.tweens.add({targets:echo,alpha:.6-i*.19,duration:65,delay:40+i*45});
    scene.tweens.add({targets:echo,y:echo.y+18,x:echo.x+12,alpha:0,duration:600,delay:200+i*80,ease:'Sine.Out'});
  }
  const text=scene.add.text(0,0,label,style).setOrigin(.5);children.push(text);
  if(critical)children.push(scene.add.text(0,-34,'คริติคอล',{fontFamily:'Noto Sans Thai, system-ui',fontStyle:'bold',fontSize:'12px',color:'#ffddb1',stroke:'#532520',strokeThickness:4}).setOrigin(.5));
  const index=Number(scene.registry.get('combat-float-index')??0);scene.registry.set('combat-float-index',index+1);
  const camera=scene.cameras.main,zoom=camera.zoom;
  const projected={x:camera.x+(x-camera.worldView.x)*zoom,y:camera.y+(y-camera.worldView.y)*zoom};
  const half=Math.max(44,text.width/2+38),edge=Math.min(half,scene.scale.width/2);
  const screenX=Phaser.Math.Clamp(projected.x+(scene.scale.height<=360?44:0)+((index%3)-1)*12,edge,scene.scale.width-edge);
  const rise=compact?18:38,minY=compact?(critical?116:94):145;
  const screenY=Math.max(projected.y-(index%2)*9,minY+rise);
  const position=camera.getWorldPoint(screenX,screenY);
  const root=scene.add.container(position.x,position.y,children).setDepth(100).setScale(.82/zoom);
  root.setData('combat-feedback',kind).setData('feedback-style','thai-trail');
  scene.tweens.add({targets:root,scale:1/zoom,duration:105,ease:'Back.Out'});
  scene.tweens.add({targets:root,y:root.y-rise/zoom,duration:920,ease:'Sine.Out'});
  scene.tweens.add({targets:root,alpha:0,delay:370,duration:550,onComplete:()=>{document.body.dataset.combatFeedbackExpired=kind;root.destroy();}});
  document.body.dataset.combatFeedback=kind;
  document.body.dataset.combatFeedbackStyle='thai-trail';
}
